import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    titlePage: null
};
export const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {
        setTitlePage: (state, action) => {
            state.titlePage = action.payload;
        }
    }
});
const { setTitlePage } = headerSlice.actions;
export const HeaderActionCreators = { setTitlePage };
export default headerSlice.reducer;
